<template>
  <div>
    <FormRowTwo
      :fieldNameArr="[$t('LENGTH') + '(mm)' + ': ', $t('WIDTH') + '(mm)' + ': ', $t('HEIGHT') + '(mm)' + ': ', $t('GROSS_WEIGHT') + '(kg)' + ': ']"
      :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
      <Input class="Input" v-model="metalQuotation.length" slot="a" :disabled="true" />
      <Input class="Input" v-model="metalQuotation.width" slot="b" :disabled="true" />
      <Input class="Input" v-model="metalQuotation.height" slot="c" :disabled="true" />
      <Input class="Input" v-model="metalQuotation.weight" slot="d" :disabled="true" />
    </FormRowTwo>
    <FormRowTwo
      :fieldNameArr="[$t('RM_VENDOR') + ': ', $t('RAW_MATERIAL_TYPE') + ': ', $t('RAW_MATERIAL_PRICE') + ': ', $t('RM_PRICE_DATE') + ': ', $t('REF_PRICE_CURRENCY') + ': ', $t('COIL_CENTER') + ': ' ]"
      :fieldWidthArr="[364, 364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102, 102]">
      <Input class="Input" v-model="rmVendor" slot="a" :disabled="true" />
      <Input class="Input" v-model="rmType" slot="b" :disabled="true" />
      <Input class="Input" v-model="metalQuotation.rmPrice" slot="c" :disabled="true" />
      <DatePicker class="Input" v-model="metalQuotation.rmPriceDate" type="date" format="yyyy-MM-dd"
        :placeholder="$t('RM_PRICE_DATE')" slot="d" :disabled="true"></DatePicker>
      <Input class="Input" style="color: red;" v-model="referencePrice" slot="e" :disabled="true" />
      <Input class="Input" v-model="coilCenter" slot="f" :disabled="true" />
    </FormRowTwo>
    <FormRow :fieldNameArr="[$t('')]">
      <Table width="600" border :columns="priceColumnList" :data="priceList" slot="a">
      </Table>
    </FormRow>
  </div>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import FormRowTwo from '@/components/FormRowTwo'


export default {
  name: "MetalAttributes",
  components: {
    FormRowTwo
  },
  props: {
    metalQuotation: {
      type: Object,
      default: () => null,
    },
    referencePrice: {
      type: String,
      default: () => "",
    },
    priceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      priceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.key) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.value) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        }
      ]
    }
  },
  methods: {
    ...mapGetters(["getModalSize"]),
    ...mapActions([]),
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    rmVendor() {
      return this.metalQuotation.rmVendor ? this.metalQuotation.rmVendor.vendorName : ''
    },
    rmType() {
      return this.metalQuotation.rawMaterialType ? this.metalQuotation.rawMaterialType.partNoDesc : ''
    },
    coilCenter() {
      return this.metalQuotation.coilCenter ? this.metalQuotation.coilCenter.vendorName : ''
    }
  },
}
</script>

<style scoped></style>
  